import useFullStory from '../hooks/useFullStory';

export default function FullStoryUser(props) {
  useFullStory();
  return null;
};
